import { useCallback, useState } from 'react';

import { breakpoints } from 'themes';

import { useOnWindowResize } from './useOnWindowResize';

const LayoutKind = {
  OneColumn: 'OneColumn',
  TwoColumn: 'TwoColumn',
};

const getLayoutKind = () =>
  window.innerWidth < breakpoints.md
    ? LayoutKind.OneColumn
    : LayoutKind.TwoColumn;

export const useLayoutKind = () => {
  const [layoutKind, setLayoutKind] = useState(getLayoutKind);

  const handleResize = useCallback(() => {
    setLayoutKind(getLayoutKind());
  }, []);

  useOnWindowResize(handleResize);

  return layoutKind;
};

export const useIsOneColumnLayout = () => {
  const layoutKind = useLayoutKind();

  return layoutKind === LayoutKind.OneColumn;
};
